import { FileText, Download, FileSpreadsheet, File } from "lucide-react";
import { mediaUrl } from "@/lib/api";

function DocIcon({ filename }) {
  const ext = (filename || "").split(".").pop().toLowerCase();
  if (["xls", "xlsx"].includes(ext)) return <FileSpreadsheet className="h-5 w-5 text-emerald-700" />;
  if (["pdf"].includes(ext)) return <FileText className="h-5 w-5 text-ukf-red" />;
  return <File className="h-5 w-5 text-slate-500" />;
}

export function MediaDisplay({ media }) {
  if (!media || media.length === 0) return null;
  const images = media.filter((m) => m.is_image);
  const docs = media.filter((m) => !m.is_image);

  return (
    <div className="space-y-6" data-testid="media-display">
      {images.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {images.map((m) => (
            <a
              key={m.id}
              href={mediaUrl(m.id)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`media-image-${m.id}`}
              className="group block overflow-hidden rounded-lg border border-slate-200 bg-white"
            >
              <img
                src={mediaUrl(m.id)}
                alt={m.filename}
                loading="lazy"
                className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </a>
          ))}
        </div>
      )}
      {docs.length > 0 && (
        <ul className="space-y-2">
          {docs.map((m) => (
            <li key={m.id}>
              <a
                href={mediaUrl(m.id, true)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`media-doc-${m.id}`}
                className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3 transition-colors hover:border-ukf-gold hover:bg-ukf-canvas"
              >
                <span className="flex items-center gap-3 min-w-0">
                  <DocIcon filename={m.filename} />
                  <span className="truncate text-sm font-medium text-slate-700">{m.filename}</span>
                  <span className="hidden sm:inline text-xs uppercase text-slate-400">
                    {(m.filename || "").split(".").pop()}
                  </span>
                </span>
                <Download className="h-4 w-4 shrink-0 text-slate-400" />
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
